<template>
  <div class='box'>
      <div :class="['window',learnType==1?'window1':'window2']">
          <table width="99%" border="0" cellspacing="0" cellpadding="0">
            <tbody><tr>
                <td width="29%">准考证号：</td>
                <td width="71%" height="30">
                    <input type="text" name="zkzh" id="zkzh" v-model="value1" maxlength="11">
                </td>
            </tr>
            <tr>
                <td>证件号码：</td>
                <td height="30">
                    <input type="text" name="sfzh" id="sfzh" maxlength="18" v-model="value2">
                </td>
            </tr>
            <tr>
                <td>&nbsp;</td>
                <td height="30"><font color="#ff4400" size="2"></font></td>
            </tr>
            <tr>
                <td>&nbsp;</td>
                <td height="60">
                   <img src="../../assets/img/examMoni/logonBtn1.gif" class="btn" width="72" height="25" @click="login">
                    &nbsp; <img src="../../assets/img/examMoni/logonBtn2.gif" width="72" height="25">
                </td>
            </tr>
            </tbody>
        </table>
      </div>
      <p align="left">说明：请使用准考证号：11111111111，证件号码：111111111111111111</p>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {
        value1:'11111111111',
        value2:'111111111111111111',
        learnType:1,
    };
  },
  computed:{
  },
  watch:{
  },
  methods: {
      login(){
        if(this.value1!='11111111111') alert('请按要求填写准考证号！')
        else if(this.value2!='111111111111111111') alert('请按要求填写证件号！')
        this.$router.replace({
            path:'examMoni_before',
            query: {
                course_id: this.$route.query.course_id,
                test_id: this.$route.query.test_id,
                rule_tag: this.$route.query.rule_tag,
                cid: this.$route.query.cid,
                course_chapter_id:this.$route.query.course_chapter_id,
                toptitle:this.$route.query.toptitle,
                learn_type:this.$route.query.learn_type
            }
        })
    }
  },
  created(){
      document.getElementsByClassName('top_header')[0].style.display='none'
      this.learnType = this.$route.query.learn_type
  }
};
</script>

<style lang='scss' scoped>
.box{
    background-image: url('../../assets/img/examMoni/logonBack.jpg');
    background-repeat: repeat-x;
    background-color: #f5f8fd;
    overflow: hidden;
    .window{
        margin: 0 auto;
        margin-top: 200px;
        width: 526px;
        height: 291px;
        position: relative;
        table{
            position: absolute;
            right: 20px;
            top: 100px;
            width: 294px;
            td{
                color: black;
                font-size: 14px;
            }
            .btn{
                cursor: pointer;
            }
        }
        
    }
    .window1{
        background-image: url('../../assets/img/examMoni/logonWindow.png');
    }
    .window2{
        background-image: url('../../assets/img/examMoni/logonWindow2.png');
    }
    p{
        width: 526px;
        margin: 0 auto;
        text-align: left;
        margin-top: 40px;
        color: black;
        font-size: 14px;
    }
}
</style>
